import * as apiMethods from '../../consts/api/apiMethods';
import {setCurrentProfile, setDeviceProfiles} from '../../state/ducks/deviceProfiles';
import {dispatch} from '../../state/store';
import helpers from '../../utils/helpers';
import ApiClient from '../api/clients/apiClient';
import log from '../logger/log';
import {addChirpStackProfileRequestMapping, editChirpStackProfileRequestMapping} from '../mappings/settingMappings';

const getDeviceProfilesList = async () => {
    try {
        const response = await new ApiClient().callGet({
            methodName: apiMethods.DEVICE_PROFILES,
        });

        if (response) {
            dispatch(setDeviceProfiles(response));
        }

        return response;
    } catch (e) {
        log.error(`getDeviceProfilesList: ${e}`);
    }
};

const addDeviceProfile = async (data, onSuccess) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.DEVICE_PROFILES,
            requestConfig: {
                data: addChirpStackProfileRequestMapping(data),
            },
        });

        helpers.runFunction(onSuccess);
    } catch (e) {
        log.error(`addDeviceProfile: ${e}`);
    }
};

const editDeviceProfile = async (data, onSuccess) => {
    try {
        await new ApiClient().callPut({
            methodName: apiMethods.DEVICE_PROFILES,
            requestConfig: {
                data: editChirpStackProfileRequestMapping(data),
            },
        });

        helpers.runFunction(onSuccess);
    } catch (e) {
        log.error(`editDeviceProfile: ${e}`);
    }
};

const deleteDeviceProfile = async (id, onSuccess) => {
    try {
        await new ApiClient().callDelete({
            methodName: `${apiMethods.DEVICE_PROFILES}/${id}`,
        });

        helpers.runFunction(onSuccess);
    } catch (e) {
        log.error(`deleteDeviceProfile: ${e}`);
    }
};

const getDeviceProfileDetails = (profile) => {
    dispatch(setCurrentProfile(profile));
};

const getDeviceProfileById = async (id) => {
    try {
        return await new ApiClient().callGet({
            methodName: `${apiMethods.DEVICE_PROFILES}/${id}`,
        });
    } catch (e) {
        log.error(`getDeviceProfileById: ${e}`);
        return null;
    }
};

export default {
    getDeviceProfilesList,
    addDeviceProfile,
    editDeviceProfile,
    deleteDeviceProfile,
    getDeviceProfileDetails,
    getDeviceProfileById,
};
